module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_8.0ffb76cf.png";